module.exports = __webpack_public_path__ + "img/9C.4f8d0d8f.png";